import { render, staticRenderFns } from "./MpChatItem.vue?vue&type=template&id=6e38af54&scoped=true&"
import script from "./MpChatItem.vue?vue&type=script&lang=js&"
export * from "./MpChatItem.vue?vue&type=script&lang=js&"
import style0 from "./MpChatItem.vue?vue&type=style&index=0&id=6e38af54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e38af54",
  null
  
)

component.options.__file = "MpChatItem.vue"
export default component.exports